import {
  AddCollaboratorsHistoryCourse,
  AddCollaboratorsHistoryCourseResponse,
  GetCollaboratorsHistoryCoursesResponse,
  UpdateCollaboratorsHistoryCourse,
} from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryCoursesService = {
  async list(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryCoursesResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response =
      await httpClient.get<GetCollaboratorsHistoryCoursesResponse>(
        `v1/collaborators/${collaboratorId}/history/courses?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
  async add(
    collaboratorId: number,
    body: AddCollaboratorsHistoryCourse,
  ): Promise<AddCollaboratorsHistoryCourseResponse> {
    const response = await httpClient.post<
      AddCollaboratorsHistoryCourse,
      AddCollaboratorsHistoryCourseResponse
    >(`v1/collaborators/${collaboratorId}/history/courses`, body);
    return response;
  },
  async update(
    collaboratorId: number,
    courseId: number,
    body: UpdateCollaboratorsHistoryCourse,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/courses/${courseId}`,
      body,
    );
  },
  async delete(collaboratorId: number, courseId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/courses/${courseId}`,
    );
  },
};

export default CollaboratorsHistoryCoursesService;
